import {
	buildFacet,
	loadSearchAnalyticsActions,
	loadSearchActions,
	buildResultList,
	loadAdvancedSearchQueryActions
} from "@coveo/headless";
import { useEffect, useState } from "react";
import { generateTabs } from "components/coveo-headless/controllers/Controllers";
import StickyHeader from "components/utility/sticky-header/StickyHeader";
import StickyHeaderContainer from "components/utility/sticky-header/StickyHeaderContainer";
import Tab from "./Tab";
import FilterIcon from "images/filter-icon.svg?react";
import MediaCenterFacet from "./MediaCenterFacet";
import MediaCenterResultList from "./MediaCenterResultList";
import TabMobile from "./TabMobile";
import MediaCenterFacetMobile from "./MediaCenterFacetMobile";
import {
	registerField,
	registerSearchHub,
	launchAnalytics
} from "components/coveo-headless/utils/initAnalytics";
import { ImageArrow } from "components/utility/images";

const MediaCenterController = (props) => {
	const { engine, jsonData, templates, uniqueId, searchHub } = props;
	const { filters, aq, fields, context, showMoreText, resultDescription } = jsonData;
	const { facetName } = filters;

	const [toggleMobileFacet, setToggleMobileFacet] = useState(false);
	const [toggleMobileFilter, setToggleMobileFilter] = useState(false);

	const [tabs, setTabs] = useState({});
	const [activeTab, setActiveTab] = useState("All");

	useEffect(() => {
		const setAqEgine = (engine) => {
			const initialAq = jsonData.tabs.All.tabFacet + aq;
			const action = loadAdvancedSearchQueryActions(engine).updateAdvancedSearchQueries({
				aq: initialAq
			});
			engine.dispatch(action);
		};

		setAqEgine(engine);
		const { logInterfaceLoad } = loadSearchAnalyticsActions(engine);
		const { executeSearch } = loadSearchActions(engine);
		engine.dispatch(executeSearch(logInterfaceLoad()));
		setTabs(generateTabs(engine, jsonData.tabs));
		setCookieBannerHeight();
	}, [aq, engine, jsonData.tabs]);

	// Coveo Controllers
	const facet = buildFacet(engine, {
		options: {
			field: filters.facetName[0].facetField,
			facetId: filters.facetName[0].facetField,
			numberOfValues: 10
		}
	});
	const resultList = buildResultList(engine);

	// Set Necessary preprocess values and analytics context
	launchAnalytics(engine, context);
	registerField(engine, fields);
	registerSearchHub(engine, searchHub);
	return (
		<div>
			<StickyHeaderContainer>
				<StickyHeader>
					{tabs ? (
						<div className="media-center-container">
							<div className="media-center-container-browse-bar">
								<section>
									<div className="media-center-container-browse-bar-desktop">
										<div className="insights-browse-bar-tabs">
											{Object.keys(tabs).map(function (tab) {
												return (
													<Tab key={tab} controller={tabs[tab]} engine={engine} jsonData={jsonData}>
														{tab}
													</Tab>
												);
											})}
										</div>
										<MediaCenterFacet field={facetName} facet={facet} engine={engine} />
									</div>
									<div className="media-center-container-browse-bar-mobile">
										<div className="media-center-container-browse-bar-mobile-tabs">
											<div
												onKeyDown={() => setToggleMobileFacet(!toggleMobileFacet)}
												role="button"
												tabIndex={0}
												className="media-center-container-browse-bar-mobile-tab"
												onClick={() => setToggleMobileFacet(!toggleMobileFacet)}
											>
												<span>
													{activeTab} <ImageArrow />
												</span>
											</div>
										</div>
										<div
											onKeyDown={() => setToggleMobileFilter(!toggleMobileFilter)}
											onClick={() => setToggleMobileFilter(!toggleMobileFilter)}
											role="button"
											tabIndex={0}
											className="media-center-container-browse-bar-mobile-filters"
										>
											<div className="media-center-container-browse-bar-mobile-filter">Filter</div>
											<div className="media-center-container-browse-bar-mobile-filter-img">
												<FilterIcon />
											</div>
										</div>
									</div>
								</section>
							</div>
						</div>
					) : (
						""
					)}
				</StickyHeader>
			</StickyHeaderContainer>
			<div className="media-center-container-results">
				<MediaCenterResultList
					controller={resultList}
					headlessEngine={engine}
					uniqueId={uniqueId}
					templates={templates}
					showMoreText={showMoreText}
					resultDescription={resultDescription}
				/>
			</div>
			<div
				className={
					"media-center-container-browse-bar-mobile-tabs-selection " +
					(toggleMobileFacet === true ? "show" : "hide")
				}
			>
				{Object.keys(tabs).map(function (tab) {
					return (
						<div
							key={`${tab}-mobile`}
							className="media-center-container-browse-bar-mobile-tabs-selection-item"
						>
							<TabMobile
								controller={tabs[tab]}
								engine={engine}
								jsonData={jsonData}
								setActiveTab={setActiveTab}
							>
								{tab}
							</TabMobile>
						</div>
					);
				})}
			</div>
			<div
				className={
					"media-center-mobile-filter-items " + (toggleMobileFilter === true ? "show" : "hide")
				}
			>
				<MediaCenterFacetMobile field={facetName} facets={facet} engine={engine} />
			</div>
			<div
				onKeyDown={() => setToggleMobileFacet(!toggleMobileFacet)}
				role="button"
				tabIndex={0}
				onClick={() => setToggleMobileFacet(!toggleMobileFacet)}
				className={`body-mask body-mask-${toggleMobileFacet ? "show" : "hide"} media-center-mask`}
			></div>
			<div
				onKeyDown={() => setToggleMobileFilter(!toggleMobileFilter)}
				role="button"
				tabIndex={0}
				onClick={() => setToggleMobileFilter(!toggleMobileFilter)}
				className={`body-mask body-mask-${toggleMobileFilter ? "show" : "hide"} media-center-mask`}
			></div>
		</div>
	);
};

const setCookieBannerHeight = () => {
	const div = document.querySelector(".cookies-non-essential-container ");
	if (div) {
		div.classList.add("media-center-cookies-non-essential-container");
	}
};
export default MediaCenterController;
